<template>
  <svg
    width="24px"
    height="24px"
    viewBox="0 0 24 24"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>icons / 24x24 / publish</title>
    <g
      id="icons-/-24x24-/-publish"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <g
        id="upload-cloud"
        transform="translate(0.000000, 3.000000)"
        stroke-width="2"
      >
        <polyline
          id="Path"
          stroke="#000000"
          points="16 13 12 9 8 13"
        ></polyline>
        <line x1="12" y1="9" x2="12" y2="18" id="Path" stroke="#97ABBE"></line>
        <path
          d="M20.39,15.39 C22.3963878,14.2961756 23.4058732,11.9812616 22.8422071,9.76669062 C22.278541,7.55211965 20.2851787,6.00150875 18,6 L16.74,6 C15.9110812,2.79381476 13.1924313,0.429775738 9.90220351,0.0541009621 C6.61197575,-0.321573814 3.43039912,1.3687835 1.90007949,4.30559334 C0.369759869,7.24240319 0.807078934,10.818503 3,13.3"
          id="Path"
          stroke="#97ABBE"
        ></path>
        <polyline
          id="Path"
          stroke="#97ABBE"
          points="16 13 12 9 8 13"
        ></polyline>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: "icon"
};
</script>